import { render, staticRenderFns } from "./CompanyCases.vue?vue&type=template&id=4c636308&scoped=true&"
import script from "./CompanyCases.vue?vue&type=script&lang=js&"
export * from "./CompanyCases.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCases.vue?vue&type=style&index=0&id=4c636308&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c636308",
  null
  
)

export default component.exports